module.exports = __webpack_public_path__ + "img/pager2img.919c9183.png";